import {
  CUSTOM_COMPANIES_PATH,
  FAVORITES_PATH,
  MANAGE_ACCESS_PATH,
} from '@upright/ui/common/generic/components/navigation/page-paths';
import { showSharedAssets, useFrontPageConfig } from '@upright/ui/views/home-views/front-page-config';
import { Item, ItemLink, Section, MenuTitleSmall } from '../../../shared-menus';

export function SavedItemsBlock(props: { canSeeCustomCompanies: boolean }) {
  const { canSeeCustomCompanies } = props;
  const frontPageConfig = useFrontPageConfig();
  return (
    <Section>
      <MenuTitleSmall>Saved Items</MenuTitleSmall>
      <Item>
        <ItemLink to={FAVORITES_PATH}>Favorites</ItemLink>
      </Item>
      {showSharedAssets(frontPageConfig.clientType) && (
        <Item>
          <ItemLink to={MANAGE_ACCESS_PATH}>Manage access</ItemLink>
        </Item>
      )}
      {canSeeCustomCompanies && (
        <Item>
          <ItemLink to={CUSTOM_COMPANIES_PATH}>Custom companies</ItemLink>
        </Item>
      )}
    </Section>
  );
}
